import React from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { ApiHost } from '../../config'
import Breadcrumbs from '../../components/Breadcrumbs'
import { ngssDimensionIconCode } from '../../util'

//importing related to onboarding guide
import { OnboardingGuideBanner } from '../../components/OnboardingHomepage'
import { OnboardingTeacherContext } from '../../contexts/OnboardingTeacherContextProvider'

import pinwheel from '../../assets/img/loading-pinwheel.gif'
import ImageHeader from '../../components/ImageHeader'
import headerImage from '../../assets/img/banners/Explore_Plan_Cover.jpg'
import HintButton from '../../components/HintButton'
import tippsWaveImage from '../../assets/img/Tipps_Wave.PNG'
import tippsGreetingImage from '../../assets/img/Tipps_Greeting.png'
import tippsGoodJobImage from '../../assets/img/Tipps_GoodJob.PNG'
import tippsShirtImage from '../../assets/img/Tipps_Shirt.PNG'
import '../../assets/css/pages/track_progress/track-progress-page.css'
import FilterContainer from '../../containers/FilterContainer/index'
import ExpandableOverview from '../../components/ExpandableOverview'
import ImageEmptyState from '../../components/ImageEmptyState'
import TytoSelect from '../../components/TytoSelect'
import ProgressOverviewRow from './ProgressOverviewRow'
import NgssDimensionsRow from './NgssDimensionsRow'
import PerformanceExpectationRow from './PerformanceExpectationRow'
import StrugglingAreaRow from './StrugglingAreaRow'
import AdditionalFilters from './AdditionalFilters'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ExpeditionProgressRow } from './ExpeditionProgressRow'
library.add(faCircle)

class TrackProgressPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = { isDownloading: false }
		this.firstWidgetRow = React.createRef()
	}

	componentDidUpdate() {
		const row = this.firstWidgetRow.current
		if (!_.isEmpty(row)) {
			// Reset the widgets to their un-constrainted heights. This allows changes in the widgets
			// content (ie, after loadings) to still affect the widgets' height
			_.each(row.children, c => (c.style.height = 'initial'))
			const maxChildHeight = _.max(_.map(row.children, c => c.offsetHeight))

			// Set each widget to use the height of the tallest un-constrained child
			_.each(row.children, c => (c.style.height = `${maxChildHeight}px`))
		}
	}

	ngssDimensionOptions = [
		{ value: 1, label: 'All Dimensions (CCCs, DCIs, & SEPs)' },
		{ value: 2, label: 'Cross-Cutting Concepts' },
		{ value: 3, label: 'Disciplinary Core Ideas' },
		{ value: 4, label: 'Scientific and Engineering Practices' }
	]

	contentOptions = [
		{ value: 1, label: 'Assigned Content Only' },
		{ value: 2, label: 'All Content' }
	]

	getPEHintComponent = () => {
		return (
			<div className='pe-hint'>
				This chart reflects student performance for the Performance Expectations for which
				they have completed quests. You can use this data to assign them remedial content in
				areas that they are struggling in.
				<br />
				<br />
				<div className='pe-legend incomplete'>
					<FontAwesomeIcon icon='circle' /> = Not completed
				</div>
				<div className='pe-legend great-struggle'>
					<FontAwesomeIcon icon='circle' /> = Completed with a lot of struggle
				</div>
				<div className='pe-legend struggle'>
					<FontAwesomeIcon icon='circle' /> = Completed with struggle
				</div>
				<div className='pe-legend no-struggle'>
					<FontAwesomeIcon icon='circle' /> = Completed well
				</div>
			</div>
		)
	}

	getProgressOverviewFilterElement = () => (
		<AdditionalFilters
			selectedProgressType={this.props.selectedProgressOverviewShowAllContent}
			selectedModuleIds={this.props.selectedProgressOverviewModuleIds}
			selectedContentTypes={this.props.selectedProgressOverviewContentTypes}
			setShowAllContent={this.props.setProgressOverviewShowAllContent}
			toggleModuleId={this.props.toggleProgressOverviewModuleId}
			toggleContentType={this.props.toggleProgressOverviewContentType}
			commitFilters={this.props.commitProgressOverviewFilters}
			revertSelectedFilters={this.props.revertProgressOverviewFilters}
			typeOptions={[
				{ value: 1, label: 'Storyline' },
				{ value: 2, label: 'Practice' },
				{ value: 3, label: 'Enrichment' }
			]}
			moduleOptions={_.map(this.props.modules, mod => ({ value: mod.id, label: mod.name }))}
		/>
	)

	getGenericEmptyFilterState = () => (
		<ImageEmptyState
			src={tippsWaveImage}
			className='content-item'
			imageProps={{ style: { maxWidth: '240px' } }}
			text='No results! Try broadening or changing your filters.'
		/>
	)

	getGenericNoDataState = () => (
		<ImageEmptyState
			src={tippsGreetingImage}
			className='content-item'
			imageProps={{ style: { maxWidth: '200px' } }}
			text='Your students have not progressed enough to show data. Check back after completing some quests!'
		/>
	)

	getPOEmptyState = () => {
		const { anyFilteredProgresses } = this.props

		if (anyFilteredProgresses) {
			return this.getGenericEmptyFilterState()
		} else {
			return this.getGenericNoDataState()
		}
	}

	handleProgressGridView = (e, id) => {
		if (this.props.selectedProgressGridSectionId) {
			this.setState({ isDownloading: true, downloadError: '' })
			fetch(
				`${ApiHost()}progress_grid?s3=true&section_ids=${
					this.props.selectedProgressGridSectionId
				}`,
				{
					method: 'GET',
					credentials: 'include'
				}
			)
				.then(response => response.json())
				.then(json => {
					this.setState({ isDownloading: false })
					if (!_.isEmpty(json.url)) {
						window.open(json.url, '_blank')
					} else {
						this.setState({ downloadError: 'Sorry, something went wrong.' })
					}
				})
		} else {
			this.setState({ downloadError: 'Please specify at least 1 class' })
		}
	}

	handleProgressGridDownload = () => {
		if (this.props.selectedProgressGridSectionId) {
			this.setState({ isDownloading: true, downloadError: '' })
			fetch(
				`${ApiHost()}progress_grid?section_ids=${this.props.selectedProgressGridSectionId}`,
				{
					method: 'GET',
					credentials: 'include'
				}
			)
				.then(response => response.blob())
				.then(blob => {
					const url = window.URL.createObjectURL(blob)
					let el = document.createElement('a')
					el.href = url
					el.download = 'completion_grid.html'
					document.body.appendChild(el)
					el.click()
					el.remove()
					this.setState({ isDownloading: false })
				})
		} else {
			this.setState({ downloadError: 'Please specify at least 1 class' })
		}
	}

	renderImportHint = () => {
		return (
			<ul>
				<li>Open any Google Sheets file</li>
				<li>Select File &gt; Import</li>
				<li>Select the Upload tab and upload the spreadsheet you just downloaded</li>
			</ul>
		)
	}

	getSAEmptyState = () => {
		const { anyFilteredStrugglingAreas, anyCompletedProgresses } = this.props

		if (anyFilteredStrugglingAreas) {
			return this.getGenericEmptyFilterState()
		} else if (anyCompletedProgresses) {
			return (
				<ImageEmptyState
					src={tippsGoodJobImage}
					className='content-item'
					imageProps={{ style: { maxWidth: '240px' } }}
					text='Your students are doing great! They are not struggling on any of their tasks.'
				/>
			)
		} else {
			return this.getGenericNoDataState()
		}
	}

	// Ie, the page is neither loading nor has data to display
	hasEmptyProgressState = () => !this.props.isLoading && !this.props.anyProgresses

	//onboarding guide context => the same as useContext in functional components
	static contextType = OnboardingTeacherContext

	render() {
		const {
			isLoading,
			sectionCollection,
			selectedProgressGridSectionId,
			handleProgressGridSectionChange,
			strugglingAreasData,
			performanceExpectationData,
			modules,
			progressData,
			selectedStudentGroupings,
			moduleProgress,
			peProgress,
			anyProgresses,
			quests
		} = this.props

		// Progress Overview Filtering Callbacks and Data
		const {
			progressOverviewFilters,
			setProgressOverviewShowAllContent,
			toggleProgressOverviewModuleId,
			toggleProgressOverviewContentType,
			commitProgressOverviewFilters,
			revertProgressOverviewFilters,
			setNgssDimensionsShowAllContent,
			setNgssDimensionsContentType,
			setPerformanceExpectationsShowAllContent,
			togglePerformanceExpectationsModuleId,
			expeditionAssignments
		} = this.props

		return (
			<ImageHeader
				image={headerImage}
				titleContents='Track Progress'
				containerClass='modules-container'>
				{!this.hasEmptyProgressState() && (
					<FilterContainer dateFilter={true} contentFilter={false} />
				)}
				<div id='track-progress-page'>
					{!this.context.isAllComplete && (
						<div style={{ padding: '1em' }}>
							<OnboardingGuideBanner />
						</div>
					)}

					{!this.hasEmptyProgressState() && (
						<div className='row-wrappers'>
							<div className='expandable-row' ref={this.firstWidgetRow}>
								<ExpandableOverview
									key='struggling-areas'
									previewSize={4}
									title='Struggling Areas'
									previewText='There $$are %% more Struggling $$Areas'
									isLoading={isLoading}
									hint="These struggling areas have been identified based on students' performance on specific tasks and quests where certain students had a lot of struggle, as a quick view of where students need the most help.">
									<div className='expandable-content'>
										{!_.isEmpty(strugglingAreasData) &&
											_.map(strugglingAreasData, row => (
												<StrugglingAreaRow
													key={JSON.stringify(row)}
													studentCount={row.count}
													studentPercentage={row.percentage}
													dimensionItem={row.dimensionItem}
													workProductType={row.workProductType}
													quests={row.quests}
													className='content-item'
												/>
											))}
										{_.isEmpty(strugglingAreasData) && this.getSAEmptyState()}
									</div>
								</ExpandableOverview>

								<ExpandableOverview
									key='performance-expectations'
									previewSize={3}
									title='Performance Expectations'
									previewText='There $$are %% more Performance $$Expectations'
									hint={this.getPEHintComponent()}
									isLoading={isLoading}>
									<div className='persistent-content' id='persistent-pes-header'>
										<span className='filter-text'>Showing:</span>
										<span className='dimension-filter'>
											<TytoSelect
												selections={
													this.props.performanceExpectationsShowAllContent
														? 2
														: 1
												}
												options={this.contentOptions}
												placeholderTextUsesSelection={true}
												onSelect={val =>
													setPerformanceExpectationsShowAllContent(
														val === 2
													)
												}
											/>
										</span>
										<span className='show-all-filter'>
											<TytoSelect
												selections={
													this.props.performanceExpectationsModuleIds
												}
												options={_.map(modules, mod => ({
													value: mod.id,
													label: mod.name
												}))}
												multiple={true}
												placeholder={
													_.isEmpty(
														this.props.performanceExpectationsModuleIds
													)
														? 'In All Modules'
														: 'In Selected Modules'
												}
												onSelect={id =>
													togglePerformanceExpectationsModuleId(id)
												}
											/>
										</span>
									</div>
									<div className='expandable-content'>
										{!_.isEmpty(performanceExpectationData) &&
											_.map(performanceExpectationData, peRow => (
												<PerformanceExpectationRow
													key={peRow.code}
													code={peRow.code}
													description={peRow.description}
													cccs={peRow.cccs}
													dcis={peRow.dcis}
													seps={peRow.seps}
													incompletePercentage={
														peRow.percentages.incomplete
													}
													greatStrugglePercentage={
														peRow.percentages.greatStruggle
													}
													strugglePercentage={peRow.percentages.struggle}
													noStrugglePercentage={
														peRow.percentages.noStruggle
													}
													className='content-item'
												/>
											))}
									</div>
								</ExpandableOverview>
							</div>

							<ExpandableOverview
								key='progress-overview'
								previewSize={5}
								isFullSize={true}
								title='Progress Overview'
								previewText='There $$are %% more $$Assignments'
								hint='This chart shows the percentage of your students that have finished each module, storyline, enrichment and/or practice quests.'
								isLoading={isLoading}>
								<div
									className='persistent-content'
									id='persistent-progress-overview-header'>
									{this.getProgressOverviewFilterElement()}
								</div>
								<div className='expandable-content'>
									{!_.isEmpty(progressData) &&
										_.map(progressData, (row, index) => (
											<ProgressOverviewRow
												key={row.subtitle + row.title}
												className='content-item'
												numberSubItems={row.isSequence}
												completionPercentage={row.completionPercentage}
												title={row.title}
												subtitle={row.subtitle}
												scale={10}
												subItems={row.quests}
												quests={quests}
											/>
										))}
									{_.isEmpty(progressData) && this.getPOEmptyState()}
								</div>

								<div className='footer-content' id='download-row'>
									<p>Need a student view summary for easier grading?</p>
									<span className='select-wrapper'>
										<TytoSelect
											selections={selectedProgressGridSectionId}
											placeholderTextUsesSelection={true}
											placeholder='Select Class To Display'
											options={sectionCollection}
											onSelect={val => handleProgressGridSectionChange(val)}
										/>
									</span>
									<button
										onClick={e =>
											this.handleProgressGridView(
												e,
												selectedProgressGridSectionId
											)
										}
										disabled={this.state.isDownloading}
										type='button'
										className='apply'>
										View Spreadsheet
									</button>
									<button
										onClick={this.handleProgressGridDownload}
										type='button'
										disabled={this.state.isDownloading}
										className='cancel'>
										Download Spreadsheet
									</button>
									{this.state.isDownloading && (
										<span>
											<img id='progress-grid-pinwheel' src={pinwheel} />
										</span>
									)}
									<span className='hint-wrapper'>
										<HintButton hint={this.renderImportHint()} />
										<span className='hint-prompt'>
											How do I import the spreadsheet after downloading?
										</span>
									</span>

									{this.state.downloadError && (
										<div className='download-error error'>
											{this.state.downloadError}
										</div>
									)}
								</div>
							</ExpandableOverview>

							<ExpandableOverview
								key='Expeditions-overview'
								previewSize={5}
								isFullSize={true}
								title='Expeditions Overview'
								previewText='There $$are %% more $$Assignments'
								hint='This chart shows the status of your students who have started their expeditions assignment.'
								isLoading={isLoading}>
								<div className='expandable-content'>
									{!_.isEmpty(expeditionAssignments) ? (
										<ExpeditionProgressRow
											expeditionAssignments={expeditionAssignments}
										/>
									) : (
										this.getPOEmptyState()
									)}
								</div>
							</ExpandableOverview>

							<ExpandableOverview
								key='ngss-dimensions'
								previewSize={5}
								isFullSize={true}
								title='Three Dimensions of the NGSS'
								previewText='There $$are %% more NGSS $$Dimensions'
								hint='This chart shows the proportion of quests students have completed that address various practices, concepts, and core ideas. This is intended so that you can understand which aspects they have the most exposure to, versus which may need strengthening.'
								isLoading={isLoading}>
								<div
									className='persistent-content'
									id='persistent-ngss-dimension-header'>
									<span className='filter-text'>Showing:</span>
									<span className='dimension-filter'>
										<TytoSelect
											selections={this.props.ngssDimensionsContentType}
											options={this.ngssDimensionOptions}
											placeholderTextUsesSelection={true}
											onSelect={setNgssDimensionsContentType}
										/>
									</span>
									<span className='show-all-filter'>
										<TytoSelect
											selections={
												this.props.ngssDimensionsShowAllContent ? 2 : 1
											}
											options={this.contentOptions}
											placeholderTextUsesSelection={true}
											onSelect={val =>
												setNgssDimensionsShowAllContent(val === 2)
											}
										/>
									</span>
								</div>
								<div className='expandable-content'>
									{_.flatMap(
										this.props.ngssDimensionData,
										(items, dimensionName) =>
											_.map(items, (row, index) => (
												<NgssDimensionsRow
													key={JSON.stringify(row)}
													sectionTitle={index === 0 ? dimensionName : ''}
													className='content-item'
													dimensionType={row.type}
													title={row.name}
													percentage={row.percentage}
												/>
											))
									)}
								</div>
							</ExpandableOverview>
						</div>
					)}
					{this.hasEmptyProgressState() && (
						<div className='full-page-empty-state'>
							<img src={tippsShirtImage} />
							<div className='title'>No Content Completed</div>
							<div className='text-wrapper'>
								<div className='text'>
									Your students have not completed content within Tyto Online yet.
									Go to <Link to='modules'>Explore & Assign</Link> to assign some
									quests to your students. Assessment data will then automatically
									begin to appear here as they complete the quests!
								</div>
							</div>
						</div>
					)}
				</div>
			</ImageHeader>
		)
	}
}
export default TrackProgressPage
